<template>
    <div class="vue-megamenu-navbar" >
        <div v-for="(category, index) in sections"
            class="vue-megamenu__section"
            :index="index"
            :key="category.id"
            :class="{ active: activeCategory === category && isOpen}"
            >
            <a
                :href="addStoreToUrl(category.url, storeTitle)"
                class="vue-megamenu__section__link"
                @mouseenter="mouseenter(category)"
                @mouseleave="mouseleave($event)"
                @click.stop="click(category, $event)"
                :class="{ active: activeCategory === category && isOpen}"
                >
                <picture v-if="category.image">
                    <img :src="category.image.replace(/(.jpg|.png)/, '_ew40_ew40.webp')" width="40" height="40" loading="lazy"/>
                </picture>
                <span>{{ category.name }}</span>
            </a>

            <a :href="category.url" class="vue-megamenu__section__categories-all vue-megamenu-arrow"><span>{{ $t("megamenu.allCategories") }}</span></a>

            <container
                :category="category"
                :links="links.bottom[category.id] ? links.bottom[category.id] : undefined"
                :isActive="activeCategory === category && isOpen"
                :key="category.id"
            ></container>
        </div>
        <div class="vue-megamenu-submenu" ref="submenu" >

            <a
                v-for="(link, index) in links.button"
                :key="index"
                class="vue-megamenu-button vue-megamenu-arrow-mobile"
                :href="addStoreToUrl(link.url, storeTitle)"
            >{{ link.title }}</a>

            <div class="vue-megamenu-submenu__inner">
                <div class="vue-megamenu-button"><i class="icon-dot-3"></i></div>
                <div class="vue-megamenu-submenu__inner__links">
                    <div>
                        <a
                            v-for="(link, index) in links.submenu"
                            :key="index"
                            class="vue-megamenu-arrow-mobile"
                            :href="addStoreToUrl(link.url, storeTitle)"
                        >{{ link.title }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
/* eslint-disable no-console */
import { defineComponent } from 'vue'
import Container from './Container.vue'
import addBranchSlugToUrl from '@/helper/addBranchSlugToUrl'
import useStore from './../store'
import { ICategory, IButtonLink, ISubmenuLink, IBottomLinkGroupList } from './../type'

const store = useStore(window.pinia)

export default defineComponent({
    props: ['activeCategory'],
    data () {
        return {
            links: {
                button: [] as IButtonLink[],
                submenu: [] as ISubmenuLink[],
                bottom: {} as IBottomLinkGroupList,
            },
        }
    },
    computed: {
        isOpen (): boolean {
            return store.isOpen()
        },
        sections (): ICategory[] {
            return store.getSections()
        },
        storeTitle () {
            return window.config.getBranchSlug()
        },
        domain () {
            return window.config.getDomain() ?? ''
        },
    },
    created () {
        const links = sessionStorage.getItem('megamenu-links')
        if (links !== null) {
            this.links = JSON.parse(links)
            return
        }

        fetch(this.domain + '/ajax/megamenu-links')
            .then(response => response.json())
            .then(payload => {
                this.links = payload
                sessionStorage.setItem('megamenu-links', JSON.stringify(payload))
            })
            .catch(error => {
                console.error(error)
            })
    },
    methods: {
        addStoreToUrl: addBranchSlugToUrl,
        mouseenter (category: ICategory) {
            // If screen more than 980px.
            if (window.matchMedia('(min-width: 981px)').matches) {
                store.openCategory(category)
            }
        },
        mouseleave (event: MouseEvent) {
            // If screen more than 980px.
            // je to jenom, když přejedeš myší z megamenu do submenu (akce, témata, události, ... ).. hlavní close je v App.vue:2
            if (window.matchMedia('(min-width: 981px)').matches
                && event.relatedTarget === this.$refs.submenu) {
                store.close()
            }
        },
        click (category: ICategory, event: MouseEvent) {
            const element = event.currentTarget as HTMLAnchorElement
            // If screen eq or less than 980px
            if (window.matchMedia('(max-width: 980px)').matches) {
                event.preventDefault()
                setTimeout(() => {
                    const yCoordinate = element.getBoundingClientRect().top + window.pageYOffset
                    const yOffset = -100
                    window.scrollTo({
                        top: yCoordinate + yOffset,
                        behavior: 'smooth',
                    })
                }, 200)
                store.toggleCategory(category)
            }

            // else redirect
            // If <a> has no .active class do nothing. Mouseenter it does.
            // On other hand let it flow and redirect will happned.
            if (!element.classList.contains('active')) {
                event.preventDefault()
            }
        },
    },
    components: {
        Container,
    },
})
</script>
